import { isNumber } from 'lodash';

import { ValidateStorageOptions, ValidateWorkersOptions } from './types';

export const validateStorage = ({
  value,
  min,
  max,
  siteStorageQuota,
  t,
}: ValidateStorageOptions) => {
  if (!value)
    return {
      isValid: false,
      errorMessage: t('validations.fieldRequired'),
    };

  if (value < min)
    return {
      isValid: false,
      errorMessage: t('validations.minStorage', { min }),
    };

  if (max < siteStorageQuota && value > max)
    return {
      isValid: false,
      isExceedMaxStorage: true,
      errorMessage: t('validations.exceedAvailableStorage'),
    };

  if (max === siteStorageQuota && value > max)
    return {
      isValid: false,
      errorMessage: t('validations.maxStorage'),
    };

  return { isValid: true, isExceedMaxStorage: false };
};

export const validateWorkers = ({
  value,
  min,
  max,
  available = undefined,
  allocated = undefined,
  t,
}: ValidateWorkersOptions) => {
  const diff = value - (allocated ?? 0);

  if (!value)
    return {
      isValid: false,
      errorMessage: t('validations.fieldRequired'),
    };

  if (value < min)
    return {
      isValid: false,
      errorMessage: t('validations.minWorkers'),
    };

  if ((max < 10 && diff > max) || (isNumber(available) && diff > available))
    return {
      isValid: false,
      errorMessage: t('validations.exceedAvailableWorkers'),
    };

  if (max === 10 && value > max)
    return {
      isValid: false,
      errorMessage: t('validations.maxWorkers'),
    };

  if (isNumber(allocated) && allocated === 10 && value > 10) {
    return {
      isValid: false,
    };
  }

  return { isValid: true };
};
